<template>
    <div v-if="client">
        <nav class="navbar is-radiusless is-dark"
             v-click-outside="() => menu = false">
            <div class="navbar-brand">
                <span class="navbar-item has-text-weight-light oc-logo">Bet'N GO - {{client.name}}</span>
                <div class="navbar-burger burger"
                     @click="menu = !menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div class="navbar-menu"
                 :class="{'is-active': menu}">
                <div class="navbar-start">
                    <router-link :to="{ name: 'players' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.players" | translate}}
                    </router-link>
                    <router-link :to="{ name: 'client-pins' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.pins" | translate}}
                    </router-link>
                    <router-link :to="{ name: 'client-bets' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.bets" | translate}}
                    </router-link>
                    <router-link :to="{ name: 'payment-system' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.ps" | translate}}
                    </router-link>
                    <router-link :to="{ name: 'branch-list' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.branches" | translate}}
                    </router-link>
                    <router-link :to="{ name: 'stats' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.stats" | translate}}
                    </router-link>
                    <router-link :to="{ name: 'client-messages' }"
                                 active-class="is-active"
                                 class="navbar-item">
                        {{"topbar.messages" | translate}}
                    </router-link>
                </div>
                <div class="navbar-end">
                    <div class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-link">
                            <span class="icon has-text-grey-light">
                                <i class="fas fa-user"
                                   aria-hidden="true"></i>
                            </span>
                            <span class="user-name">{{ adminUsername }}</span>
                        </a>
                        <div class="navbar-dropdown is-boxed">
                            <a @click="logout"
                               class="navbar-item">
                                <span class="icon has-text-grey-light">
                                    <i class="fas fa-sign-out-alt"></i>
                                </span>
                                <span>{{"topbar.logout" | translate}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-link">
                            {{adminTimezone.id}} ({{adminTimezone.offset | tzoffset}})
                        </a>
                        <div class="navbar-dropdown is-right">
                            <a v-for="tz in timezones"
                               :key="tz.id"
                               class="navbar-item"
                               :class="{'is-active':adminTimezone.id == tz.id}"
                               @click="adminTimezone = tz">
                                {{tz.id}} ({{tz.offset | tzoffset}})
                            </a>
                        </div>
                    </div>
                    <div class="navbar-item has-dropdown is-hoverable is-hidden-touch">
                        <a class="navbar-link">
                            <span>{{lang}}</span>
                        </a>
                        <div class="navbar-dropdown is-right">
                            <a v-for="l in availableLanguages"
                               :key="l"
                               class="navbar-item"
                               @click="lang=l">
                                <span>{{l}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import userService from "../services/user.service";
import state from "../state";

export default {
    name: "topbar",
    data() {
        return {
            menu: false
        };
    },
    computed: {
        client() {
            return state.client.get();
        },
        adminUsername() {
            return state.admin.get() && state.admin.get().username;
        },
        timezones() {
            return state.timezones.get();
        },
        adminTimezone: {
            get() {
                return state.adminTimezone.get();
            },
            set(val) {
                state.adminTimezone.set(val);
            }
        },
        lang: {
            get() {
                return state.lang.get();
            },
            set(val) {
                state.lang.set(val);
            }
        },
        availableLanguages() {
            return state.availableLanguages.get();
        }
    },
    methods: {
        async logout() {
            await userService.logout();
            state.admin.unset();
            state.client.unset();
            state.currencies.set([]);
            this.$router.push({ name: "login" });
        }
    }
};
</script>
<style scoped>
.oc-logo {
    color: #88c0ff !important;
}
.user-name {
    margin-right: 8px;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/topbar.vue